import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig } from './app-config';
import { BaseService } from './base/base.service';
import * as uuid from 'uuid';

import { Scenario, PlanningReportVersion } from '../models';
import { ReportGenerationConstants } from '../constants';

// This service is provided in app.module.ts
// due to use in modal component
@Injectable({
  providedIn: 'root'
})
export class PlanningApiService extends BaseService<any> {

  constructor(protected http: HttpClient, protected config: AppConfig) {
    super(http, config);
  }

  public getJurisdictionMetaData(jurisdictionIds) {
    const apiUrl = `${this.getResourceUrl()}planning/jurisdiction`;
    const body = jurisdictionIds;
    return this.http.post<any>(apiUrl, body);
  }

  public runPlanning(scenario: Scenario) {
    const apiUrl = `${this.getResourceUrl()}planning/run`;

    let scenarioClone = JSON.parse(JSON.stringify(scenario));

    // This must be moved after demo
    scenarioClone.projections = scenarioClone.projections.map(projection => {
      const majorClassifications = [];
      const minorClassifications = [];
      if (projection.classifications.selectedClassifications) {
        let selectedClassifications =
          projection.classifications.selectedClassifications;
        selectedClassifications.forEach(major => {
          delete major.minorServiceClassifications;
          if (major.selectedMinors) {
            major.selectedMinors.forEach(minor => {
              minorClassifications.push(minor);
            });
          }
          delete major.selectedMinors;
          majorClassifications.push(major);
        });

        projection.classifications = {
          majorClassifications,
          minorClassifications
        };
      }
      return projection;
    });

    const body = scenarioClone;

    return this.http.post<any>(apiUrl, body);
  }

  public loadProjectionsByScenario(scenarioData) {
    const apiUrl = `${this.getResourceUrl()}scenario/${
      scenarioData.planningScenarioId
    }/projections/load`;
    const body = { projectionIds: scenarioData.projectionIds };
    return this.http.post<any>(apiUrl, body);
  }

  public loadScenarios() {
    const queryString = `?id=${uuid.v4()}`;
    const apiUrl = `${this.getResourceUrl()}scenario/load${queryString}`;
    return this.http.get<any>(apiUrl);
  }

  public saveScenario(scenario: Scenario) {
    const apiUrl = `${this.getResourceUrl()}scenario/${
      scenario.planningScenarioId
    }/save`;
    const body = scenario;
    return this.http.post<any>(apiUrl, body);
  }

  public getPlanningReportsForScenario(scenarioId: string): Observable<PlanningReportVersion[]> {
    const requestUrl = `${this.config.getBaseApiUrl()}${ReportGenerationConstants.REPORT_RESOURCE_ROUTES.PLANNING}scenario/${scenarioId}`;

    return this.http.get<PlanningReportVersion[]>(requestUrl);
  }

  protected getResourceUrl(): string {
    return this.config.getPlanningApiUrl();
  }

}
